import { useEffect } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { I18nextProvider } from "react-i18next";
import Routes from "./routes";
import i18n from "./localization/i18n";
import Store, { history } from "./store";

const store = Store();

const App = () => {
  useEffect(() => {
    i18n.changeLanguage("id");
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </Provider>
    </I18nextProvider>
  );
};

export default App;
